const stringFormatMixin = {
  methods: {
    strReplace: function(str, var1, var2) {
      if (typeof str == "undefined" || str == null) return "";

      if (typeof var1 == "undefined" || var1 == null) return str;

      if (typeof var2 == "undefined" || var2 == null) return str;

      return str.split(var1).join(var2);
    },
    extractContent: function(content) {
      var span = document.createElement("span");
      span.innerHTML = content;
      return span.textContent || span.innerText;
    },
    removerAcentos: function(newStringComAcento) {
      var string = newStringComAcento;
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
      };

      for (var letra in mapaAcentosHex) {
        var expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
      }

      return string;
    },
    inArray: function(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    showPercent: function(percent) {
      if (percent == "-" || percent == null || percent == "") return "-";
      return percent + "%";
    },
    formatPercent: function(number) {
      if (number == "Imune" || number == "Isento") return number;

      if (number !== null && typeof number !== "undefined") {
        number = number.toString().replace(",", ".");

        if (isNaN(parseFloat(number))) return number;

        number = parseFloat(number);

        return (
          number
            .toFixed(2)
            .replace(",00", "")
            .replace(".00", "")
            .replace(".50", ".5")
            .replace(".", ",") + "%"
        );
      }

      return null;
    },

    formatPercentFixed: function(number, fixed) {
      if (number == "Imune" || number == "Isento") return number;

      if (number !== null && typeof number !== "undefined") {
        number = number.toString().replace(",", ".");

        if (isNaN(parseFloat(number))) return number;

        number = parseFloat(number);

        return (
          number
            .toFixed(fixed)
            .toString()
            .replace(".", ",") + "%"
        );
      }

      return null;
    },

    moneyToNumber(money) {
      return Number(
        money
          .replace("R$ ", "")
          .replaceAll(".", "")
          .replace(",", ".")
      );
    }
  }
};

export default stringFormatMixin;
